export function setnotifications(notifications) {
  return {
    type: 'SET_NOTIFICATIONS',
    notifications,
  };
}

export function setpedidoscounter(pedidos) {
  return {
    type: 'SET_PEDIDOS_COUNTER',
    pedidos,
  };
}

export function setrefoundscounter(refounds) {
  return {
    type: 'SET_REFOUNDS_COUNTER',
    refounds,
  };
}
